import { render, staticRenderFns } from "./OperaDeclareAnswerWindow.vue?vue&type=template&id=d04b1bb4&"
import script from "./OperaDeclareAnswerWindow.vue?vue&type=script&lang=js&"
export * from "./OperaDeclareAnswerWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports